module.exports = __webpack_public_path__ + "static/media/scholar_g.cea338cb.png";